export const colorPrimary = '#012169';

export const EXCAVATION_COLOR = '#108001';
export const EXCAVATION_COLOR_SECONDARY = '#174D10';
export const BUILD_COLOR = '#FC8008';
export const BUILD_COLOR_SECONDARY = '#B05B05';
